<template>
  <div class="mt-3">
    <social-sharing
      url="https://www.unstitched.xyz/"
      title="Can't wait for the launch of www.unstitched.xyz - Artificial intelligence meets menswear!"
      description="Discover the outfits hidden in your wardrobe."
      quote="Can't wait for the launch of www.unstitched.xyz - Artificial intelligence meets menswear!"
      hashtags="Unstitched,fashTech,AI,Menswear"
      twitter-user="unstitched_xyz"
      inline-template
    >
      <ul class="social-buttons-list rounded text-center mb-0 py-3">
        <li
          class="social-button-item list-inline-item mr-1 position-relative facebook"
        >
          <network network="facebook" class="social-button-link">
            <font-awesome-icon
              :icon="['fab', 'facebook-f']"
              size="2x"
              class="social-icon position-absolute"
            />
          </network>
        </li>
        <li
          class="social-button-item list-inline-item mr-1 position-relative twitter"
        >
          <network network="twitter" class="social-button-link">
            <font-awesome-icon
              :icon="['fab', 'twitter']"
              size="2x"
              class="social-icon position-absolute"
            />
          </network>
        </li>
      </ul>
    </social-sharing>
  </div>
</template>

<script>
import { bus } from "@/main";

export default {
  mounted() {
    bus.$on("openSignUpModal", () => {
      if (this.$refs.signUpModalRef) this.$refs.signUpModalRef.show();
    });
  }
};
</script>

<style lang="scss" scoped></style>



// WEBPACK FOOTER //
// src/components/landing/SocialButtons.vue